import React, { useEffect, useState } from "react";
import "./style.scss";
import { Link, useLocation } from "react-router-dom";

function CardList({ filterData }) {
  const location = useLocation();
  const [cards, setCards] = useState([]);


  useEffect(() => {
    if (filterData) {
      setCards(filterData);
    }
  }, [filterData]);
  
  useEffect(() => {
    if (filterData === null) {
      setCards([]); 
    }
  }, [filterData]);
  

  const generateBookingLink = (centerId, city_id) => {
    const currentPath = location.pathname;

    const accessKey = currentPath.split("/day-pass/")[1].split("?")[0];

    const startTime = document.getElementById('date-filter').value;

    const queryParams = new URLSearchParams(window.location.search);
    const utm_source = queryParams.get("utm_source");
    const utm_medium = queryParams.get("utm_medium");
    const utm_campaign = queryParams.get("utm_campaign");
    let bookingLink = ''
    if(utm_source || utm_medium || utm_campaign){
      bookingLink = `/day-pass/book-now/${accessKey}?utm_source=${utm_source}&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}&city_id=${city_id}&start_time=${startTime}&center_id=${centerId}`;
    }
    else{
      bookingLink = `/day-pass/book-now/${accessKey}?city_id=${city_id}&start_time=${startTime}&center_id=${centerId}`;
    }


    return bookingLink;
  };

  return (
    <div className="card-list col-md-12">
      {console.log("card :> ", cards)}
      {cards.map((item, index) => (
        <div key={item.id} className="cardDayPass row">
       
       <div className="col-md-6">
            {/* Wrap the image in a link to the booking page */
            item.image_gallery && (
              <a
                href={generateBookingLink(item.id, item.city_id)}
                style={{ textDecoration: 'none' }}
              >
                <img
                  className="card-img"
                  loading="lazy"
                  src={
                    JSON.parse(item.image_gallery)[index % JSON.parse(item.image_gallery).length]
                  }
                  alt={`${item.name} Image`}
                />
              </a>
            )}
          </div>

          <div className="card-details col-md-6 pt-sm-20 listing-detail listing-detail-view-day">
          <h3 className="listing-heading">
              <a
                href={generateBookingLink(item.id, item.city_id)}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                {item.name}
              </a>
            </h3>
            <p className="listing-sub-heading">{item.address}</p>
            {/* <p className="listing-sub-heading">{item?.location_name}</p> */}
            <div className="book-slot-box pb-4">
              <div className="price-box">
                <p className="price">
                  <span className="rupee-text">₹</span>
                  <span>{parseInt(item.price_per_seat_per_day)}/-</span>
                </p>
                <p className="price-sub-text">
                  Base Rate: {parseInt(item.price_per_seat_per_day)}/day
                </p>
              </div>
              <div className="book-btn-box">
                <Link to={generateBookingLink(item.id, item.city_id)} className="book-slot-btn">
                  BOOK NOW
                </Link>
              </div>
            </div>
          </div>
        </div>
      ))}
      {cards.length === 0 && <div className="loader"></div>}
    </div>
  );
}

export default CardList;
